export enum StrategyRatingColor {
  Unknown = '#DBDBDB',
  NotEffective = '#CC3333',
  NeedMoreInfo = '#DDBA00',
  Effective = '#A6D4A5',
  VeryEffective = '#037429',
}